import React, {Component} from 'react';
import {connect} from 'react-redux';
import {filter} from 'lodash';
import {reduxForm, FieldArray, Field, formValueSelector} from 'redux-form';
import {Modal, Table, Form, Dropdown, Loader, Button, Grid, Popup, Icon} from 'semantic-ui-react';
import {ordersStatus, tasksStatus} from '../../../../common/dictionaries/accessories';
import {TECHNICIAN_ASSIGNMENT_FORM} from '../../../../common/forms';
import {Actions} from '../../../../common/actions';
import './technicianAssignment.scss';

class TechnicianAssignmentModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'modalWasOpen': false,
    };
    this.renderTable = this.renderTable.bind(this);
    this.onCloseModalClick = this.onCloseModalClick.bind(this);
    this.onSaveAssignmentClick = this.onSaveAssignmentClick.bind(this);
  }

  fetchData() {
    const {accessoryOrder} = this.props;
    this.setState({'modalWasOpen': true});
    const params = {'chassis': accessoryOrder.chassis, 'katashiki': accessoryOrder.katashiki};
    this.props.fetchTasksByOrder(accessoryOrder.order, params);
    this.props.fetchTechnicians();
  }

  onCloseModalClick() {
    this.setState({'modalWasOpen': false});
  }

  onSaveAssignmentClick() {
    const {accessoryOrder, tasks, filters, type} = this.props;
    const data = {...filters, type};
    this.props.addTechniciansToTasksByOrder(accessoryOrder.order, {tasks}, data);
    this.onCloseModalClick();
  }
  
  renderTriggerIcon(accessoryOrder) {
    if (accessoryOrder.anticipatedInvoice === 'S' &&
      (accessoryOrder.status === ordersStatus.closed_order ||
        // accessoryOrder.status === ordersStatus.created_order ||
        accessoryOrder.status === ordersStatus.wash_wait)) {
      return null;
    }
    return (
      <Icon name='user' size='large'
        color={accessoryOrder.status === ordersStatus.created_order ||
        accessoryOrder.status === ordersStatus.anticipated_invoiced_order &&
        accessoryOrder.worked !== 'S' ? 'grey' : 'green'} />
    );
  }

  renderTechniciansDropdown = (field) => {
    return (
      <Dropdown selection
        name={`technician-container-${field.index}`}
        upward={field.index > 3}
        options={field.options}
        defaultValue={field.defaultValue}
        search
        onChange={(e, {value}) => field.input.onChange(value)}
        closeOnChange
        disabled={field.disabled}
        loading={field.loading}
        placeholder='Técnico'
        noResultsMessage='Técnico no encontrado'
      />
    );
  }

  renderItems(fields, techniciansOptions) {
    const {techniciansLoading} = this.props;
    if (!fields.length) {
      return (
        <Table.Row>
          <Table.Cell textAlign='center' colSpan={6}>No hay datos Disponibles</Table.Cell>
        </Table.Row>
      );
    }

    return fields.map((item, index) => {
      const element = fields.get(index);
      const taskNotStarted = element.status === ordersStatus.created_order ||
        element.status === ordersStatus.assigned_technicians;
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='center'>{element.serviceCode3}</Table.Cell>
          <Table.Cell textAlign='center'>{element.description}</Table.Cell>
          <Table.Cell textAlign='center'>
            <Field
              name={`${item}.technician`}
              component={this.renderTechniciansDropdown}
              options={techniciansOptions}
              index={index}
              defaultValue={element.technician}
              disabled={techniciansLoading || !taskNotStarted}
              loading={techniciansLoading}
            />
          </Table.Cell>
          <Table.Cell textAlign='center'>{element.localFlat}</Table.Cell>
          <Table.Cell textAlign='center'>
            <Icon name='circle' size='large'
              color={element.status === tasksStatus.finished_task ? 'green' : 'grey inverted'} />
          </Table.Cell>
        </Table.Row>
      );
    });
  }

  getTechniciansOptions() {
    return this.props.techniciansList.map((item) => {
      return {'text': `${item.technician} - ${item.name}`, 'value': item.technician};
    });
  }

  renderData(fields) {
    const {tasksLoading} = this.props;

    if (tasksLoading) {
      return (
        <Table.Row className='loader'>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }
    const techniciansOptions = this.getTechniciansOptions();
    return this.renderItems(fields, techniciansOptions);
  }
  
  renderTable({fields}) {
    return (
      <Table striped className='toyota-grid'>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell textAlign='center'>Código de Tarea</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>Descripción</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>Técnico</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>Tiempo Tarea</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>Estado</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {this.renderData(fields)}
        </Table.Body>
      </Table>
    );
  }

  render() {
    const {accessoryOrder, tasks, type, sfx} = this.props;
    const {modalWasOpen} = this.state;

    if (!accessoryOrder.order) {
      return <div />;
    }

    const tasksWithTechnician = filter(tasks, 'technician');

    return (
      <Modal size='fullscreen' className='technician-assignment-modal'
        onOpen={() => this.fetchData()}
        open={modalWasOpen}
        trigger={
          <span className='link'>
            <Popup
              trigger={this.renderTriggerIcon(accessoryOrder)}
              content="Asignar Técnicos"
              position='top right'
              inverted
            />
          </span>
        }>

        <Modal.Header>
          Asignación de técnicos para la orden: {accessoryOrder.order}
        </Modal.Header>
        
        <Modal.Content scrolling>
          <Modal.Description>
            <div className='title-bar'>
              <div className='filters-section'>
                <Grid textAlign='left'>
                  <Grid.Row>
                    <Grid.Column width={1}>
                      <h4>Katashiki:</h4>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      {sfx} / {accessoryOrder.katashiki}
                    </Grid.Column>
                    <Grid.Column width={1}>
                      <h4>Modelo:</h4>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      {accessoryOrder.description}
                    </Grid.Column>
                    <Grid.Column width={1}>
                      <h4>Chasis:</h4>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      {accessoryOrder.chassis}
                    </Grid.Column>
                    <Grid.Column width={1}>
                      {type === 'accessories' &&
                      <h4>Combo:</h4>}
                    </Grid.Column>
                    <Grid.Column width={2}>
                      {type === 'accessories' &&
                      accessoryOrder.combo}
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </div>
            </div>

            <Form className='primary-content'>
              <FieldArray name="tasks" component={this.renderTable} />
            </Form>
          </Modal.Description>
        </Modal.Content>

        <Modal.Actions>
          <Button onClick={this.onCloseModalClick}>
            Cancelar
          </Button>
          {(accessoryOrder.status === ordersStatus.created_order ||
            accessoryOrder.status === ordersStatus.anticipated_invoiced_order &&
            accessoryOrder.worked !== 'S' ||
            accessoryOrder.status === ordersStatus.assigned_technicians) &&
          <Button positive
            disabled={tasks.length !== tasksWithTechnician.length}
            onClick={this.onSaveAssignmentClick}>
            Guardar
          </Button>
          }
        </Modal.Actions>
      </Modal>
    );
  }
}

export {TechnicianAssignmentModal};

const form = reduxForm({
  'form': TECHNICIAN_ASSIGNMENT_FORM.name,
})(TechnicianAssignmentModal);

const mapStateToProps = (state) => {
  const formValues = formValueSelector(TECHNICIAN_ASSIGNMENT_FORM.name);
  const tasks = formValues(state, 'tasks');

  return {
    'tasksLoading': state.form.techniciansAssignment.loading,
    tasks,
    'techniciansLoading': state.techniciansAssignment.loading,
    'techniciansList': state.techniciansAssignment.list,
    'sfx': state.techniciansAssignment.sfx,
    'date': state.accessoriesOrders.searchDate,
  };
};

const {
  fetchTechnicians,
  fetchTasksByOrder,
  addTechniciansToTasksByOrder,
} = Actions;

export default connect(mapStateToProps, {
  fetchTechnicians,
  fetchTasksByOrder,
  addTechniciansToTasksByOrder,
})(form);
